<template>
  <v-container>
    <h2 class="hyp-header">Evacuation and Risk Rating Changes</h2>
    <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
    <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
    <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
  </v-container>
</template>

<script>
export default {
  name: "RiskRatingChanges",
};
</script>

<style scoped>
.hyp-header {
  margin-bottom: 20px;
}
</style>
